export default __webpack_public_path__ + "static/media/14_living room.30f83a19.png";